import { siteInfo } from "@/mocks/comicData";

const footerLinks = [
  { label: "主角介绍", href: "#protagonist" },
  { label: "角色设定", href: "#roles" },
  { label: "人物关系", href: "#relationships" },
  { label: "剧情看点", href: "#arcs" },
  { label: "热门内容", href: "#recommend" },
  { label: "常见问题", href: "#faq" },
];

const categories = ["继母与继姐漫画", "人物关系", "角色设定", "主角介绍"];

export default function Footer() {
  return (
    <footer className="bg-background-200/60">
      <div className="mx-auto max-w-6xl px-4 md:px-6 py-12 md:py-16">
        <div className="grid gap-8 md:grid-cols-[1.4fr_1fr_1fr]">
          <div className="flex flex-col gap-4">
            <a href="#hero" className="flex items-center gap-2 whitespace-nowrap" aria-label="返回顶部">
              <span className="grid w-9 h-9 place-items-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-home-heart-fill w-4 h-4 flex items-center justify-center"></i>
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">
                {siteInfo.officialSite}
              </span>
            </a>
            <p className="max-w-sm text-sm leading-relaxed text-foreground-600">
              {siteInfo.name} 角色关系聚合站，专注主角介绍、继母与继姐角色设定及人物关系梳理，帮你快速看懂每一段互动逻辑。
            </p>
            <p className="font-heading text-sm font-semibold text-primary-700 italic">
              「{siteInfo.tagline}」
            </p>
          </div>

          <div>
            <h3 className="mb-4 text-sm font-bold text-foreground-900">内容导航</h3>
            <ul className="flex flex-col gap-2.5">
              {footerLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="mb-4 text-sm font-bold text-foreground-900">主题分类</h3>
            <ul className="flex flex-col gap-2.5">
              {categories.map((cat) => (
                <li key={cat}>
                  <a
                    href="#roles"
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                  >
                    {cat}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-300/60 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-500">
            © {new Date().getFullYear()} {siteInfo.officialSite} · 本站为角色关系指南，不提供漫画原文内容
          </p>
          <div className="flex items-center gap-4">
            <a href="#contact" className="text-xs text-foreground-500 hover:text-primary-600">
              联系我们
            </a>
            <a href="#about" className="text-xs text-foreground-500 hover:text-primary-600">
              关于本站
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}